import React from 'react';
import PropTypes from 'prop-types';
import {
  Tabs,
} from 'antd';

import { Spinner } from '../UI';

import styles from './Panes.module.css';

const { TabPane } = Tabs;

const Panes = ({
    type,
    items,
    loading,
    handleTab,
  }) => {
  return (
    <div className={styles.panes}>
      <Tabs
        type={type}
        onChange={handleTab}
      >
        {items.map(({ key, tab, child }) => (
          <TabPane
            key={key}
            tab={tab}
          >
            {!loading ? child : <Spinner size="small"/>}
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

Panes.propTypes = {
  type: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired
};

export default Panes;
